export const INTERACTION = 'INTERACTION';
